import axios from "axios";
import { config } from "../constants/config";
import { getAccessToken } from "../webapi/AuthService";
const apiUrl = config.API_URL;

class UploadService {
  getSasToken = (jwtToken, filename) => {
    const data = {
      jwt: jwtToken,
      filename
    };
    return axios({
      method: "post",
      url: config.AZURE_GET_UPLOAD_SAS_TOKEN_URL,
      data: data
    })
      .then(res => (res ? res.data.sas_token : ""))
      .catch(error => {
        console.log(error);
        return "";
      });
  };

  getJwtToken = filename => {
    const data = { fileName: filename };
    return axios({
      method: "post",
      url: `${apiUrl}/Upload/GetAzureUploadToken`,
      data: data,
      headers: {
        Authorization: getAccessToken()
      }
    })
      .then(res => res.data)
      .catch(error => "");
  };

  isSasTokenExpired = sasToken => {
    const expirationDate = this.getValueBetween(sasToken, "se=", "&").replace(
      /%3A/g,
      ":"
    );

    if (!expirationDate) return true;

    return new Date() >= new Date(expirationDate);
  };

  getValueBetween = (value, start, end) => {
    const startIndex = value.indexOf(start);
    if (startIndex < 0) return "";

    const endIndex = value.indexOf(end, startIndex);
    if (endIndex < 0) return "";

    return value.substring(startIndex + start.length, endIndex);
  };
}

export default new UploadService();
